import styled, { css } from 'styled-components'
import { themeColor } from 'LibNeo'

export const GridWrapperStyled = styled.div`
	display: flex;
	flex-direction: column;
	height: 100%;
	overflow: hidden;
	width: 100%;
	position: relative;
	background-color: ${themeColor('white')};
	border-radius: 6px;
	border: 1px solid ${themeColor('gray', 3)};
	word-break: break-word;
`

export const GridBackgroundBlockStyled = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	height: 100%;
`

export const GridLoadingBlockStyled = styled(GridBackgroundBlockStyled)<{ fullScreen?: boolean }>`
	background-color: ${themeColor('white')};
	z-index: 1;

	${({ fullScreen }) =>
		fullScreen &&
		css`
			position: absolute;
			top: 0;
		`}
`
